module.exports = __webpack_public_path__ + "img/cancelar.3a920cc7.png";